import { Image } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';

import { Token } from '../model';
import type { TokenRegister } from './types';

export const getZkCroToken: TokenRegister = (desiredNetwork, sdks) => {
  return {
    type: Token.zkCRO,
    symbol: 'zkCRO',
    addressL1: sdks.L1.getContractAddress('ZkCRO'),
    addressL2: sdks.L2.getContractAddress('ZkCRO'),
    addressCronosEvm: '',
    decimals: 18,
    displayDecimals: 6,
    Icon: (props) => (
      <Image
        src={getAssetUrl('/images/chains/zkevm.svg')}
        boxSize="24px"
        // eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
        alt="zkCro"
        {...props}
      />
    ),
  };
};
